"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InitResponseFileInfo = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(InitResponseFileInfo, _UploadOptionsBase);

  var _super = _createSuper(InitResponseFileInfo);

  /**
   * Constructs a new file instance using the provided information.
   *
   * @param {object} options Options controlling the overall process.
   * @param {DirectBinaryUploadOptions} uploadOptions Options controlling the upload process.
   * @param {UploadFile} uploadFile The original upload file from which the init data is based.
   * @param {object} fileData Raw file data as received from the init api.
   */
  function InitResponseFileInfo(options, uploadOptions, uploadFile, fileData) {
    var _this;

    _classCallCheck(this, InitResponseFileInfo);

    _this = _super.call(this, options, uploadOptions);
    _this.uploadFile = uploadFile;
    _this.fileData = fileData;
    return _this;
  }
  /**
   * Retrieves all of the URIs to which the file should be uploaded. Multiple URIs indicate that
   * the file should be uploaded in parts.
   *
   * @returns {Array} An array of URIs.
   */


  _createClass(InitResponseFileInfo, [{
    key: "getUploadUris",
    value: function getUploadUris() {
      var _this$fileData$upload = this.fileData.uploadURIs,
          uploadURIs = _this$fileData$upload === void 0 ? [] : _this$fileData$upload;
      return uploadURIs;
    }
    /**
     * Retrieves the upload token for the file, which should be used when sending the complete
     * direct binary upload request.
     *
     * @returns {string} The file's upload token.
     */

  }, {
    key: "getUploadToken",
    value: function getUploadToken() {
      return this.fileData.uploadToken;
    }
    /**
     * Retrieves the full path to the location where the file will be uploaded in the target instance.
     *
     * @returns {string} Full path to the file.
     */

  }, {
    key: "getTargetFilePath",
    value: function getTargetFilePath() {
      return "".concat(this.getUploadOptions().getTargetFolderPath(), "/").concat(this.getFileName());
    }
    /**
     * Retrieves the name of the file as provided in the upload options.
     *
     * @returns {string} The file's name.
     */

  }, {
    key: "getFileName",
    value: function getFileName() {
      return this.fileData.fileName;
    }
    /**
     * Retrieves the size of the file, in bytes, as provided in the upload options.
     *
     * @returns {number} File size in bytes.
     */

  }, {
    key: "getFileSize",
    value: function getFileSize() {
      return this.uploadFile.getFileSize();
    }
    /**
     * Retrieves a value indicating whether or not a new version of the file should be
     * created if it already exists.
     *
     * @returns {boolean} True if a new version should be created, false otherwise.
     */

  }, {
    key: "shouldCreateNewVersion",
    value: function shouldCreateNewVersion() {
      return this.uploadFile.shouldCreateNewVersion();
    }
    /**
     * Retrieves the label of the new version should one need to be created.
     *
     * @returns {string} A version label.
     */

  }, {
    key: "getVersionLabel",
    value: function getVersionLabel() {
      return this.uploadFile.getVersionLabel();
    }
    /**
     * Retrieves the comment of the new version should one need to be created.
     *
     * @returns {string} A version comment.
     */

  }, {
    key: "getVersionComment",
    value: function getVersionComment() {
      return this.uploadFile.getVersionComment();
    }
    /**
     * Retrieves a value indicating whether or not the asset should be replaced if
     * it already exists.
     *
     * @returns {boolean} True if the asset should be replaced, false otherwise.
     */

  }, {
    key: "shouldReplace",
    value: function shouldReplace() {
      return this.uploadFile.shouldReplace();
    }
    /**
     * Retrieves the mime type of the file, which will be an HTTP content type.
     *
     * @returns {string} An HTTP content type value.
     */

  }, {
    key: "getMimeType",
    value: function getMimeType() {
      return this.fileData.mimeType;
    }
    /**
     * Retrieves the maximum size, in bytes, that any one part of the file can be when uploading.
     *
     * @returns {number} Size in bytes.
     */

  }, {
    key: "getMaxPartSize",
    value: function getMaxPartSize() {
      return this.fileData.maxPartSize;
    }
    /**
     * Retrieves the minimum size, in bytes, that any one part of the file must be when uploading.
     *
     * @returns {number} Size in bytes.
     */

  }, {
    key: "getMinPartSize",
    value: function getMinPartSize() {
      return this.fileData.minPartSize;
    }
    /**
     * Retrieves a raw value from the file's data.
     *
     * @param {string} propertyName
     * @returns {*} The corresponding property value, or undefined if not found.
     */

  }, {
    key: "getFileData",
    value: function getFileData(propertyName) {
      return this.fileData[propertyName];
    }
    /**
     * Retrieves data from the target file, based on a byte range within the file.
     *
     * @param {number} startOffset The byte offset, inclusive, within the file where the chunk should start.
     * @param {number} endOffset The byte offset, exclusive, within the file where the chunk should end.
     * @returns {Readable|Array} Either a stream or an array containing the requested byte range.
     */

  }, {
    key: "getFileChunk",
    value: function getFileChunk(startOffset, endOffset) {
      return this.uploadFile.getFileChunk(startOffset, endOffset);
    }
    /**
     * Retrieves the file's information that should be included in events relating to the file.
     *
     * @returns {object} Event information for the file.
     */

  }, {
    key: "getFileEventData",
    value: function getFileEventData() {
      var targetFolder = decodeURI(this.getUploadOptions().getTargetFolderPath());
      return {
        fileName: this.getFileName(),
        fileSize: this.getFileSize(),
        targetFolder: targetFolder,
        targetFile: "".concat(targetFolder, "/").concat(this.getFileName()),
        mimeType: this.getMimeType()
      };
    }
    /**
     * Retrieves the total number of parts for the file.
     *
     * @return {number} Part count.
     */

  }, {
    key: "getFilePartCount",
    value: function getFilePartCount() {
      return this.getUploadUris().length;
    }
    /**
     * Calculates the part size for each part in which the file should be uploaded. This is calculated based
     * on the total size of the file and the number of upload URIs provided by the init API.
     *
     * @returns {number} Part size in bytes.
     */

  }, {
    key: "getFilePartSize",
    value: function getFilePartSize() {
      var fileSize = this.getFileSize();
      var numUris = this.getUploadUris().length;
      var partSize = Math.ceil(fileSize / numUris);
      return partSize;
    }
    /**
     * Converts the instance into a simple object containing the class's relevant data.
     *
     * @return {object} A simplified view of the instance.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.fileData;
    }
  }]);

  return InitResponseFileInfo;
}(_uploadOptionsBase.default);

exports.default = InitResponseFileInfo;